module.exports = __webpack_public_path__ + "static/media/treino.ef1f9cd2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/statics/bottombar/treino.svg
// module id = ./src/statics/bottombar/treino.svg
// module chunks = 0